module.exports = __webpack_public_path__ + "static/img/FIAT.15b1b87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/FIAT.png
// module id = uZdZ
// module chunks = 1